import { groupActivitiesByDate } from '@valuecase/common'
import { ActivitiesPerDay } from '../../activities/ActivitiesPerDay'
import { useMemo } from 'react'
import { useSpaceSidebar } from '../context/SpaceSidebarDataContext'
import ActivitySummaryCard from '../../activities/ActivitySummaryCard'
import { Skeleton } from '../../../components/ui/skeleton'
import NoActivitiesYet from '../../activities/NoActivitiesYet'

const ActivitiesTab = () => {
  const { activities: activitiesData, onCopySpaceLink, getBlockTitle } = useSpaceSidebar()
  const activities = useMemo(() => activitiesData?.data?.activities ?? [], [activitiesData])
  const sessions = useMemo(() => activitiesData?.data?.sessions ?? [], [activitiesData])

  const filteredAndGroupedActivities = useMemo(() => {
    return groupActivitiesByDate(activities)
  }, [activities])

  if (activitiesData?.isLoading) {
    return (
      <div className='p-5 h-full overflow-y-auto bg-grey-s1'>
        <div className='space-y-4'>
          {/* Activity Summary Card Skeleton */}
          <div className='w-full mt-2 p-3 border border-grey-s2 rounded-lg bg-white flex justify-between'>
            {[...Array(4)].map((_, index) => (
              <div key={index} className='flex flex-col'>
                <div className='flex items-center gap-1'>
                  <Skeleton className='w-4 h-4' />
                  <Skeleton className='h-6 w-8' />
                </div>
                <Skeleton className='h-3 w-16 mt-1' />
              </div>
            ))}
          </div>

          {/* Activities by Date Skeleton */}
          {[...Array(3)].map((_, index) => (
            <div key={index} className='space-y-2'>
              <Skeleton className='h-4 w-32 mb-2 mx-auto' />
              {[...Array(4)].map((_, activityIndex) => (
                <div key={activityIndex} className='flex gap-2'>
                  <Skeleton className='w-4 h-4' />
                  <div className='flex flex-col gap-1 flex-grow'>
                    <Skeleton className='h-4 w-48' />
                    <Skeleton className='h-3 w-24' />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (!activitiesData?.isLoading && activities.length === 0) {
    return (
      <div className='flex p-5 items-center justify-center'>
        <NoActivitiesYet onShare={onCopySpaceLink} />
      </div>
    )
  }

  return (
    <div className='p-5 h-full overflow-y-auto'>
      <div className='text-grey-s5'>
        <ActivitySummaryCard
          activities={activities}
          sessions={sessions}
          sessionCount={sessions.length ?? 0}
        />
        <div className='space-y-4 mt-3'>
          {Object.keys(filteredAndGroupedActivities).map((date) => {
            const activities = filteredAndGroupedActivities[date]
            return (
              <ActivitiesPerDay
                sessions={sessions}
                key={date}
                date={date}
                activities={activities}
                // @TODO: Leave this for Space sidebar wave 2 - not needed right now
                latestTimeReadActivities={null}
                onShowPageOrBlock={() => {}}
                onShowActivityTaskDetails={() => {}}
                getBlockTitle={getBlockTitle}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ActivitiesTab
